﻿[
  {
    "draftJersey": "003",
    "name": "Xavier Garcia",
    "age": 24,
    "foot": "right",
    "height": 174,
    "weight": 69,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/003.jpg",
    "macros": {
      "speed": 74,
      "passing": 83,
      "physical": 69,
      "shooting": 70,
      "talent": 66,
      "defence": 71
    },
    "profileYtVideoId": "Qh2coI2S0tY"
  },
  {
    "draftJersey": "004",
    "name": "Iker López",
    "age": 19,
    "foot": "right",
    "height": 180,
    "weight": 68,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/004.jpg",
    "macros": {
      "speed": 73,
      "passing": 84,
      "physical": 67,
      "shooting": 79,
      "talent": 69,
      "defence": 71
    },
    "profileYtVideoId": "M1g3evHJ_V0"
  },
  {
    "draftJersey": "005",
    "name": "Joel Bañuls",
    "age": 21,
    "foot": "left",
    "height": 173,
    "weight": 65,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/005.jpg",
    "macros": {
      "speed": 71,
      "passing": 76,
      "physical": 58,
      "shooting": 81,
      "talent": 76,
      "defence": 80
    },
    "profileYtVideoId": "e6xOD0vaWN8"
  },
  {
    "draftJersey": "006",
    "name": "Flavio Ruggeri",
    "age": 22,
    "foot": "right",
    "height": 174,
    "weight": 68,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/006.jpg",
    "macros": {
      "speed": 70,
      "passing": 68,
      "physical": 56,
      "shooting": 68,
      "talent": 81,
      "defence": 85
    },
    "profileYtVideoId": "BSgZ6GW5TDE"
  },
  {
    "draftJersey": "007",
    "name": "Iñaki Villalba",
    "age": 22,
    "foot": "right",
    "height": 180,
    "weight": 80,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/007.jpg",
    "macros": {
      "speed": 73,
      "passing": 75,
      "physical": 64,
      "shooting": 79,
      "talent": 70,
      "defence": 70
    },
    "profileYtVideoId": "3ZXw_YbBVow"
  },
  {
    "draftJersey": "008",
    "name": "David Cabezas",
    "age": 22,
    "foot": "right",
    "height": 181,
    "weight": 77,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/008.jpg",
    "macros": {
      "speed": 72,
      "passing": 69,
      "physical": 72,
      "shooting": 67,
      "talent": 73,
      "defence": 69
    },
    "profileYtVideoId": "fbsluV-18p4"
  },
  {
    "draftJersey": "009",
    "name": "Toti Sàlvia",
    "age": 21,
    "foot": "right",
    "height": 171,
    "weight": 63,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/009.jpg",
    "macros": {
      "speed": 72,
      "passing": 69,
      "physical": 58,
      "shooting": 80,
      "talent": 78,
      "defence": 73
    },
    "profileYtVideoId": "R_Pn2gGOb8A"
  },
  {
    "draftJersey": "011",
    "name": "Edgar Alvaro",
    "age": 22,
    "foot": "right",
    "height": 181,
    "weight": 75,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/011.jpg",
    "macros": {
      "speed": 73,
      "passing": 55,
      "physical": 82,
      "shooting": 81,
      "talent": 85,
      "defence": 70
    },
    "profileYtVideoId": "ldLQSNpGo98"
  },
  {
    "draftJersey": "012",
    "name": "Steven Rodríguez",
    "age": 20,
    "foot": "left",
    "height": 182,
    "weight": 70,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/012.jpg",
    "macros": {
      "speed": 72,
      "passing": 53,
      "physical": 49,
      "shooting": 72,
      "talent": 75,
      "defence": 79
    },
    "profileYtVideoId": "G3QJ-5pHNQU"
  },
  {
    "draftJersey": "013",
    "name": "Pau Mañé",
    "age": 25,
    "foot": "right",
    "height": 173,
    "weight": 73,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/013.jpg",
    "macros": {
      "speed": 83,
      "passing": 77,
      "physical": 69,
      "shooting": 82,
      "talent": 80,
      "defence": 69
    },
    "profileYtVideoId": "owhGAB8o3Bw"
  },
  {
    "draftJersey": "018",
    "name": "Roman Alegre",
    "age": 20,
    "foot": "left",
    "height": 184,
    "weight": 81,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/018.jpg",
    "macros": {
      "speed": 73,
      "passing": 76,
      "physical": 71,
      "shooting": 68,
      "talent": 86,
      "defence": 66
    },
    "profileYtVideoId": "fiTFrESxS6o"
  },
  {
    "draftJersey": "020",
    "name": "Jadir Cirera",
    "age": 26,
    "foot": "right",
    "height": 187,
    "weight": 90,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/020.jpg",
    "macros": {
      "speed": 72,
      "passing": 57,
      "physical": 55,
      "shooting": 67,
      "talent": 58,
      "defence": 68
    },
    "profileYtVideoId": "OAklmNLiZ7E"
  },
  {
    "draftJersey": "021",
    "name": "Álvaro García",
    "age": 26,
    "foot": "right",
    "height": 182,
    "weight": 75,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/021.jpg",
    "macros": {
      "speed": 72,
      "passing": 78,
      "physical": 69,
      "shooting": 79,
      "talent": 77,
      "defence": 65
    },
    "profileYtVideoId": "0NvOlSfDh9U"
  },
  {
    "draftJersey": "023",
    "name": "Raúl Lao",
    "age": 20,
    "foot": "left",
    "height": 178,
    "weight": 78,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/023.jpg",
    "macros": {
      "speed": 73,
      "passing": 65,
      "physical": 69,
      "shooting": 89,
      "talent": 74,
      "defence": 77
    },
    "profileYtVideoId": "vsTl_frbsd4"
  },
  {
    "draftJersey": "024",
    "name": "Joan Inés",
    "age": 25,
    "foot": "right",
    "height": 186,
    "weight": 73,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/024.jpg",
    "macros": {
      "speed": 72,
      "passing": 64,
      "physical": 60,
      "shooting": 78,
      "talent": 64,
      "defence": 63
    },
    "profileYtVideoId": "J5yRZzF3l0Y"
  },
  {
    "draftJersey": "025",
    "name": "Joan Poch",
    "age": 21,
    "foot": "left",
    "height": 189,
    "weight": 76,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/025.jpg",
    "macros": {
      "speed": 68,
      "passing": 79,
      "physical": 53,
      "shooting": 84,
      "talent": 79,
      "defence": 73
    },
    "profileYtVideoId": "6Fz6Fh-fSFU"
  },
  {
    "draftJersey": "026",
    "name": "Marc Granero",
    "age": 21,
    "foot": "left",
    "height": 183,
    "weight": 77,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/026.jpg",
    "macros": {
      "speed": 72,
      "passing": 65,
      "physical": 62,
      "shooting": 70,
      "talent": 56,
      "defence": 72
    },
    "profileYtVideoId": "JNn5XVwywFQ"
  },
  {
    "draftJersey": "027",
    "name": "Victor Sotelo",
    "age": 20,
    "foot": "right",
    "height": 161,
    "weight": 57,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/027.jpg",
    "macros": {
      "speed": 72,
      "passing": 79,
      "physical": 51,
      "shooting": 76,
      "talent": 54,
      "defence": 59
    },
    "profileYtVideoId": "L1FK4xguiNo"
  },
  {
    "draftJersey": "028",
    "name": "Kilian Honorato",
    "age": 23,
    "foot": "right",
    "height": 182,
    "weight": 77,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/028.jpg",
    "macros": {
      "speed": 72,
      "passing": 69,
      "physical": 70,
      "shooting": 87,
      "talent": 78,
      "defence": 73
    },
    "profileYtVideoId": "-euQVk5BW9E"
  },
  {
    "draftJersey": "031",
    "name": "Ian González",
    "age": 19,
    "foot": "right",
    "height": 186,
    "weight": 82,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/031.jpg",
    "macros": {
      "speed": 87,
      "passing": 54,
      "physical": 54,
      "shooting": 64,
      "talent": 74,
      "defence": 76
    },
    "profileYtVideoId": "0w-_Cb7NwmA"
  },
  {
    "draftJersey": "032",
    "name": "Arnau Martínez",
    "age": 23,
    "foot": "right",
    "height": 185,
    "weight": 88,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/032.jpg",
    "macros": {
      "speed": 74,
      "passing": 60,
      "physical": 62,
      "shooting": 81,
      "talent": 68,
      "defence": 82
    },
    "profileYtVideoId": "PRLAXNuT5io"
  },
  {
    "draftJersey": "034",
    "name": "David López",
    "age": 34,
    "foot": "left",
    "height": 177,
    "weight": 78,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/034.jpg",
    "macros": {
      "speed": 70,
      "passing": 62,
      "physical": 48,
      "shooting": 80,
      "talent": 81,
      "defence": 75
    },
    "profileYtVideoId": "MisYyOHPX88"
  },
  {
    "draftJersey": "037",
    "name": "Lucca Ribeiro",
    "age": 20,
    "foot": "left",
    "height": 170,
    "weight": 65,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/037.jpg",
    "macros": {
      "speed": 72,
      "passing": 50,
      "physical": 77,
      "shooting": 77,
      "talent": 77,
      "defence": 83
    },
    "profileYtVideoId": "mY3uLwNAAx8"
  },
  {
    "draftJersey": "038",
    "name": "Bernat Juarez",
    "age": 26,
    "foot": "right",
    "height": 180,
    "weight": 68,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/038.jpg",
    "macros": {
      "speed": 71,
      "passing": 55,
      "physical": 65,
      "shooting": 75,
      "talent": 71,
      "defence": 77
    },
    "profileYtVideoId": "bYZymDze56A"
  },
  {
    "draftJersey": "039",
    "name": "Mark Sorroche",
    "age": 18,
    "foot": "right",
    "height": 180,
    "weight": 66,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/039.jpg",
    "macros": {
      "speed": 93,
      "passing": 58,
      "physical": 74,
      "shooting": 87,
      "talent": 78,
      "defence": 73
    },
    "profileYtVideoId": "pAnUA5uPrek"
  },
  {
    "draftJersey": "040",
    "name": "Marino Gómez",
    "age": 25,
    "foot": "right",
    "height": 173,
    "weight": 67,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/040.jpg",
    "macros": {
      "speed": 73,
      "passing": 83,
      "physical": 59,
      "shooting": 81,
      "talent": 68,
      "defence": 69
    },
    "profileYtVideoId": "vaI_hWa0wQ0"
  },
  {
    "draftJersey": "041",
    "name": "Joan Mariné",
    "age": 26,
    "foot": "right",
    "height": 177,
    "weight": 69,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/041.jpg",
    "macros": {
      "speed": 71,
      "passing": 55,
      "physical": 50,
      "shooting": 72,
      "talent": 73,
      "defence": 77
    },
    "profileYtVideoId": "t_iTPcfbEAo"
  },
  {
    "draftJersey": "042",
    "name": "Roger de la Villa",
    "age": 26,
    "foot": "right",
    "height": 174,
    "weight": 68,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/042.jpg",
    "macros": {
      "speed": 73,
      "passing": 68,
      "physical": 61,
      "shooting": 81,
      "talent": 78,
      "defence": 69
    },
    "profileYtVideoId": "Ystk8lxsbcs"
  },
  {
    "draftJersey": "043",
    "name": "Sergio del Pino",
    "age": 34,
    "foot": "right",
    "height": 177,
    "weight": 100,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/043.jpg",
    "macros": {
      "speed": 72,
      "passing": 66,
      "physical": 44,
      "shooting": 65,
      "talent": 72,
      "defence": 70
    },
    "profileYtVideoId": "hdYs5-wr1Mc"
  },
  {
    "draftJersey": "044",
    "name": "Daniel Pérez",
    "age": 25,
    "foot": "right",
    "height": 174,
    "weight": 75,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/044.jpg",
    "macros": {
      "speed": 96,
      "passing": 88,
      "physical": 75,
      "shooting": 78,
      "talent": 66,
      "defence": 62
    },
    "profileYtVideoId": "tkDa0rJ1tP0"
  },
  {
    "draftJersey": "047",
    "name": "Daniel Santiago",
    "age": 21,
    "foot": "right",
    "height": 188,
    "weight": 87,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/047.jpg",
    "macros": {
      "speed": 64,
      "passing": 55,
      "physical": 69,
      "shooting": 79,
      "talent": 75,
      "defence": 83
    },
    "profileYtVideoId": "o0Q0OmBNzRk"
  },
  {
    "draftJersey": "048",
    "name": "Alex Campuzano",
    "age": 22,
    "foot": "right",
    "height": 179,
    "weight": 73,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/048.jpg",
    "macros": {
      "speed": 70,
      "passing": 78,
      "physical": 53,
      "shooting": 80,
      "talent": 78,
      "defence": 83
    },
    "profileYtVideoId": "evAMZjojqnk"
  },
  {
    "draftJersey": "049",
    "name": "Miquel Fernández",
    "age": 19,
    "foot": "right",
    "height": 179,
    "weight": 77,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/049.jpg",
    "macros": {
      "speed": 70,
      "passing": 58,
      "physical": 53,
      "shooting": 86,
      "talent": 55,
      "defence": 69
    },
    "profileYtVideoId": "AJuZe4z-r-k"
  },
  {
    "draftJersey": "051",
    "name": "Cristian Ubón",
    "age": 21,
    "foot": "right",
    "height": 176,
    "weight": 76,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/051.jpg",
    "macros": {
      "speed": 69,
      "passing": 73,
      "physical": 52,
      "shooting": 78,
      "talent": 81,
      "defence": 85
    },
    "profileYtVideoId": "t_3_bcjWr6I"
  },
  {
    "draftJersey": "052",
    "name": "Franc Cortés",
    "age": 21,
    "foot": "right",
    "height": 181,
    "weight": 73,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/052.jpg",
    "macros": {
      "speed": 64,
      "passing": 87,
      "physical": 46,
      "shooting": 77,
      "talent": 81,
      "defence": 74
    },
    "profileYtVideoId": "U8nuRhi3TVA"
  },
  {
    "draftJersey": "053",
    "name": "Marcel Miquel",
    "age": 26,
    "foot": "left",
    "height": 183,
    "weight": 71,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/053.jpg",
    "macros": {
      "speed": 64,
      "passing": 56,
      "physical": 47,
      "shooting": 76,
      "talent": 71,
      "defence": 74
    },
    "profileYtVideoId": "OAWY0QKlwig"
  },
  {
    "draftJersey": "054",
    "name": "Teimurazi Korkotashvili",
    "age": 28,
    "foot": "right",
    "height": 168,
    "weight": 58,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/054.jpg",
    "macros": {
      "speed": 72,
      "passing": 74,
      "physical": 45,
      "shooting": 75,
      "talent": 73,
      "defence": 70
    },
    "profileYtVideoId": "wEpqLIF4byA"
  },
  {
    "draftJersey": "055",
    "name": "Javier Vila",
    "age": 27,
    "foot": "right",
    "height": 182,
    "weight": 69,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/055.jpg",
    "macros": {
      "speed": 64,
      "passing": 76,
      "physical": 53,
      "shooting": 65,
      "talent": 79,
      "defence": 73
    },
    "profileYtVideoId": "zhXEE7CKG1M"
  },
  {
    "draftJersey": "056",
    "name": "Victor Hidalgo",
    "age": 24,
    "foot": "right",
    "height": 184,
    "weight": 86,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/056.jpg",
    "macros": {
      "speed": 72,
      "passing": 65,
      "physical": 56,
      "shooting": 71,
      "talent": 68,
      "defence": 74
    },
    "profileYtVideoId": "6ppLQiuYZZI"
  },
  {
    "draftJersey": "057",
    "name": "Benito Martínez",
    "age": 24,
    "foot": "right",
    "height": 180,
    "weight": 76,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/057.jpg",
    "macros": {
      "speed": 70,
      "passing": 52,
      "physical": 49,
      "shooting": 69,
      "talent": 70,
      "defence": 77
    },
    "profileYtVideoId": "cztSWd-ib5o"
  },
  {
    "draftJersey": "061",
    "name": "Marcos Guerrero",
    "age": 20,
    "foot": "right",
    "height": 175,
    "weight": 73,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/061.jpg",
    "macros": {
      "speed": 71,
      "passing": 77,
      "physical": 55,
      "shooting": 82,
      "talent": 83,
      "defence": 83
    },
    "profileYtVideoId": "IUQkeqXDims"
  },
  {
    "draftJersey": "062",
    "name": "Nacho Jordà",
    "age": 23,
    "foot": "left",
    "height": 177,
    "weight": 77,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/062.jpg",
    "macros": {
      "speed": 72,
      "passing": 79,
      "physical": 51,
      "shooting": 70,
      "talent": 64,
      "defence": 64
    },
    "profileYtVideoId": "M9btAjR0ek8"
  },
  {
    "draftJersey": "063",
    "name": "Mario Reyes",
    "age": 31,
    "foot": "left",
    "height": 172,
    "weight": 72,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/063.jpg",
    "macros": {
      "speed": 66,
      "passing": 72,
      "physical": 53,
      "shooting": 76,
      "talent": 73,
      "defence": 69
    },
    "profileYtVideoId": "fe7ddrwFgU8"
  },
  {
    "draftJersey": "064",
    "name": "David Soriano",
    "age": 22,
    "foot": "right",
    "height": 186,
    "weight": 80,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/064.jpg",
    "macros": {
      "speed": 71,
      "passing": 78,
      "physical": 70,
      "shooting": 80,
      "talent": 56,
      "defence": 57
    },
    "profileYtVideoId": "EQV7usQ2DzQ"
  },
  {
    "draftJersey": "065",
    "name": "Paulin Ntonga",
    "age": 35,
    "foot": "right",
    "height": 177,
    "weight": 85,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/065.jpg",
    "macros": {
      "speed": 71,
      "passing": 50,
      "physical": 50,
      "shooting": 63,
      "talent": 60,
      "defence": 66
    },
    "profileYtVideoId": "Do1ptI42ABs"
  },
  {
    "draftJersey": "066",
    "name": "Marc Galvany",
    "age": 18,
    "foot": "right",
    "height": 188,
    "weight": 72,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/066.jpg",
    "macros": {
      "speed": 73,
      "passing": 87,
      "physical": 63,
      "shooting": 86,
      "talent": 81,
      "defence": 90
    },
    "profileYtVideoId": "fukE6ZQ15SQ"
  },
  {
    "draftJersey": "067",
    "name": "Gilles Vidal",
    "age": 20,
    "foot": "right",
    "height": 176,
    "weight": 73,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/067.jpg",
    "macros": {
      "speed": 82,
      "passing": 81,
      "physical": 58,
      "shooting": 65,
      "talent": 81,
      "defence": 73
    },
    "profileYtVideoId": "M2m1Zf94Jcw"
  },
  {
    "draftJersey": "068",
    "name": "Joel Pascual",
    "age": 21,
    "foot": "right",
    "height": 177,
    "weight": 73,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/068.jpg",
    "macros": {
      "speed": 72,
      "passing": 69,
      "physical": 58,
      "shooting": 80,
      "talent": 66,
      "defence": 71
    },
    "profileYtVideoId": "6GwjgyiC2pM"
  },
  {
    "draftJersey": "069",
    "name": "Benjamín Sierra",
    "age": 26,
    "foot": "right",
    "height": 177,
    "weight": 76,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/069.jpg",
    "macros": {
      "speed": 73,
      "passing": 77,
      "physical": 66,
      "shooting": 66,
      "talent": 77,
      "defence": 75
    },
    "profileYtVideoId": "lx-7UphwDuc"
  },
  {
    "draftJersey": "070",
    "name": "Raul Martinez",
    "age": 20,
    "foot": "left",
    "height": 172,
    "weight": 68,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/070.jpg",
    "macros": {
      "speed": 73,
      "passing": 76,
      "physical": 50,
      "shooting": 70,
      "talent": 84,
      "defence": 73
    },
    "profileYtVideoId": "rPN8hFPZb9w"
  },
  {
    "draftJersey": "071",
    "name": "Jose Luis Blanco",
    "age": 22,
    "foot": "right",
    "height": 164,
    "weight": 65,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/071.jpg",
    "macros": {
      "speed": 73,
      "passing": 66,
      "physical": 54,
      "shooting": 65,
      "talent": 71,
      "defence": 65
    },
    "profileYtVideoId": "i6oQgbJPNL4"
  },
  {
    "draftJersey": "072",
    "name": "Adrià de Castro",
    "age": 24,
    "foot": "left",
    "height": 173,
    "weight": 65,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/072.jpg",
    "macros": {
      "speed": 70,
      "passing": 89,
      "physical": 45,
      "shooting": 80,
      "talent": 82,
      "defence": 81
    },
    "profileYtVideoId": "m9OpyujcEcE"
  },
  {
    "draftJersey": "075",
    "name": "Adrià Santiago",
    "age": 21,
    "foot": "right",
    "height": 183,
    "weight": 72,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/075.jpg",
    "macros": {
      "speed": 67,
      "passing": 74,
      "physical": 46,
      "shooting": 71,
      "talent": 78,
      "defence": 70
    },
    "profileYtVideoId": "c-lAS-TThsM"
  },
  {
    "draftJersey": "076",
    "name": "Gabriel Cichero",
    "age": 38,
    "foot": "left",
    "height": 185,
    "weight": 80,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/076.jpg",
    "macros": {
      "speed": 73,
      "passing": 75,
      "physical": 49,
      "shooting": 66,
      "talent": 76,
      "defence": 74
    },
    "profileYtVideoId": "orKcVlSJ1N8"
  },
  {
    "draftJersey": "078",
    "name": "Victor Torres",
    "age": 19,
    "foot": "left",
    "height": 190,
    "weight": 85,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/078.jpg",
    "macros": {
      "speed": 71,
      "passing": 73,
      "physical": 39,
      "shooting": 74,
      "talent": 69,
      "defence": 60
    },
    "profileYtVideoId": "B6hUrlHsdys"
  },
  {
    "draftJersey": "079",
    "name": "Aleix Ripol",
    "age": 23,
    "foot": "left",
    "height": 170,
    "weight": 68,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/079.jpg",
    "macros": {
      "speed": 72,
      "passing": 75,
      "physical": 53,
      "shooting": 76,
      "talent": 71,
      "defence": 69
    },
    "profileYtVideoId": "to3ClE7kByU"
  },
  {
    "draftJersey": "082",
    "name": "Jorge Valverde",
    "age": 29,
    "foot": "right",
    "height": 175,
    "weight": 74,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/082.jpg",
    "macros": {
      "speed": 63,
      "passing": 62,
      "physical": 54,
      "shooting": 64,
      "talent": 63,
      "defence": 68
    },
    "profileYtVideoId": "439YtQ6c9jo"
  },
  {
    "draftJersey": "083",
    "name": "Frank Martínez",
    "age": 27,
    "foot": "right",
    "height": 184,
    "weight": 86,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/083.jpg",
    "macros": {
      "speed": 72,
      "passing": 78,
      "physical": 50,
      "shooting": 74,
      "talent": 76,
      "defence": 68
    },
    "profileYtVideoId": "9k8397xhhKw"
  },
  {
    "draftJersey": "085",
    "name": "Alejandro Garcia",
    "age": 23,
    "foot": "right",
    "height": 170,
    "weight": 70,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/085.jpg",
    "macros": {
      "speed": 72,
      "passing": 70,
      "physical": 51,
      "shooting": 57,
      "talent": 68,
      "defence": 74
    },
    "profileYtVideoId": "GaCGoqfrAg8"
  },
  {
    "draftJersey": "086",
    "name": "Axel Lesan",
    "age": 24,
    "foot": "right",
    "height": 167,
    "weight": 62,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/086.jpg",
    "macros": {
      "speed": 72,
      "passing": 68,
      "physical": 56,
      "shooting": 71,
      "talent": 71,
      "defence": 73
    },
    "profileYtVideoId": "lo1AZNvS8f8"
  },
  {
    "draftJersey": "087",
    "name": "Iván López",
    "age": 26,
    "foot": "left",
    "height": 183,
    "weight": 78,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/087.jpg",
    "macros": {
      "speed": 67,
      "passing": 75,
      "physical": 47,
      "shooting": 79,
      "talent": 80,
      "defence": 71
    },
    "profileYtVideoId": "Za0lML0iLR0"
  },
  {
    "draftJersey": "088",
    "name": "Ramon Mirabet",
    "age": 38,
    "foot": "right",
    "height": 179,
    "weight": 74,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/088.jpg",
    "macros": {
      "speed": 67,
      "passing": 81,
      "physical": 41,
      "shooting": 75,
      "talent": 76,
      "defence": 60
    },
    "profileYtVideoId": "RKbaCLaoENQ"
  },
  {
    "draftJersey": "091",
    "name": "Àlex Gutiérrez",
    "age": 28,
    "foot": "left",
    "height": 180,
    "weight": 80,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/091.jpg",
    "macros": {
      "speed": 73,
      "passing": 58,
      "physical": 62,
      "shooting": 76,
      "talent": 74,
      "defence": 77
    },
    "profileYtVideoId": "b9mhN2M-Gl0"
  },
  {
    "draftJersey": "092",
    "name": "Aleix Massegú",
    "age": 27,
    "foot": "right",
    "height": 181,
    "weight": 76,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/092.jpg",
    "macros": {
      "speed": 71,
      "passing": 83,
      "physical": 76,
      "shooting": 78,
      "talent": 74,
      "defence": 79
    },
    "profileYtVideoId": "5VIjZ6RSA5o"
  },
  {
    "draftJersey": "093",
    "name": "Raúl Ledo",
    "age": 21,
    "foot": "left",
    "height": 165,
    "weight": 65,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/093.jpg",
    "macros": {
      "speed": 67,
      "passing": 72,
      "physical": 51,
      "shooting": 70,
      "talent": 81,
      "defence": 70
    },
    "profileYtVideoId": "lyOIK1cVFk4"
  },
  {
    "draftJersey": "094",
    "name": "Edu Ranchal",
    "age": 29,
    "foot": "right",
    "height": 173,
    "weight": 70,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/094.jpg",
    "macros": {
      "speed": 72,
      "passing": 72,
      "physical": 63,
      "shooting": 63,
      "talent": 74,
      "defence": 74
    },
    "profileYtVideoId": "-heFJt53vL4"
  },
  {
    "draftJersey": "095",
    "name": "Ramon Roca",
    "age": 37,
    "foot": "left",
    "height": 174,
    "weight": 70,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/095.jpg",
    "macros": {
      "speed": 70,
      "passing": 74,
      "physical": 47,
      "shooting": 53,
      "talent": 74,
      "defence": 72
    },
    "profileYtVideoId": "jOncxoNXdyo"
  },
  {
    "draftJersey": "096",
    "name": "Iván Martín",
    "age": 30,
    "foot": "right",
    "height": 180,
    "weight": 79,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/096.jpg",
    "macros": {
      "speed": 73,
      "passing": 58,
      "physical": 60,
      "shooting": 78,
      "talent": 70,
      "defence": 68
    },
    "profileYtVideoId": "mppigUJZim4"
  },
  {
    "draftJersey": "098",
    "name": "Noel López",
    "age": 22,
    "foot": "left",
    "height": 168,
    "weight": 73,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/098.jpg",
    "macros": {
      "speed": 73,
      "passing": 70,
      "physical": 68,
      "shooting": 79,
      "talent": 89,
      "defence": 67
    },
    "profileYtVideoId": "xlvasWWqg1I"
  },
  {
    "draftJersey": "099",
    "name": "Adrian Biboum",
    "age": 23,
    "foot": "right",
    "height": 185,
    "weight": 84,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/099.jpg",
    "macros": {
      "speed": 72,
      "passing": 88,
      "physical": 58,
      "shooting": 80,
      "talent": 68,
      "defence": 70
    },
    "profileYtVideoId": "JxxVUAzLP20"
  },
  {
    "draftJersey": 101,
    "name": "Ferran Gimenez",
    "age": 30,
    "foot": "right",
    "height": 172,
    "weight": 75,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/101.jpg",
    "macros": {
      "speed": 72,
      "passing": 63,
      "physical": 55,
      "shooting": 81,
      "talent": 68,
      "defence": 55
    },
    "profileYtVideoId": "9Ei2wjXn6sI"
  },
  {
    "draftJersey": 106,
    "name": "Andrew Turner",
    "age": 18,
    "foot": "right",
    "height": 174,
    "weight": 58,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/106.jpg",
    "macros": {
      "speed": 73,
      "passing": 77,
      "physical": 59,
      "shooting": 72,
      "talent": 80,
      "defence": 80
    },
    "profileYtVideoId": "CPR1bAQeTLI"
  },
  {
    "draftJersey": 108,
    "name": "Sergi Sauras",
    "age": 30,
    "foot": "right",
    "height": 189,
    "weight": 77,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/108.jpg",
    "macros": {
      "speed": 73,
      "passing": 62,
      "physical": 69,
      "shooting": 69,
      "talent": 65,
      "defence": 82
    },
    "profileYtVideoId": "BHQEIEjz-uo"
  },
  {
    "draftJersey": 109,
    "name": "Álvaro Hinojosa",
    "age": 22,
    "foot": "right",
    "height": 176,
    "weight": 73,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/109.jpg",
    "macros": {
      "speed": 73,
      "passing": 60,
      "physical": 70,
      "shooting": 81,
      "talent": 65,
      "defence": 64
    },
    "profileYtVideoId": "DsxjMbsn3vc"
  },
  {
    "draftJersey": 111,
    "name": "Iván Nuevo",
    "age": 22,
    "foot": "right",
    "height": 165,
    "weight": 63,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/111.jpg",
    "macros": {
      "speed": 70,
      "passing": 61,
      "physical": 63,
      "shooting": 80,
      "talent": 83,
      "defence": 73
    },
    "profileYtVideoId": "1onwEN-tJsc"
  },
  {
    "draftJersey": 112,
    "name": "Feliu Torrus",
    "age": 28,
    "foot": "right",
    "height": 165,
    "weight": 66,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/112.jpg",
    "macros": {
      "speed": 72,
      "passing": 60,
      "physical": 64,
      "shooting": 83,
      "talent": 82,
      "defence": 84
    },
    "profileYtVideoId": "dgsPooFHPLo"
  },
  {
    "draftJersey": 114,
    "name": "Pablo Beguer",
    "age": 27,
    "foot": "left",
    "height": 172,
    "weight": 67,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/114.jpg",
    "macros": {
      "speed": 73,
      "passing": 66,
      "physical": 57,
      "shooting": 84,
      "talent": 86,
      "defence": 71
    },
    "profileYtVideoId": "_J6-ce5rtVE"
  },
  {
    "draftJersey": 115,
    "name": "Giovanni Ferinu",
    "age": 24,
    "foot": "right",
    "height": 183,
    "weight": 81,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/115.jpg",
    "macros": {
      "speed": 71,
      "passing": 75,
      "physical": 67,
      "shooting": 74,
      "talent": 85,
      "defence": 77
    },
    "profileYtVideoId": "Q68qfiLkOh4"
  },
  {
    "draftJersey": 119,
    "name": "Bruno Gumà",
    "age": 22,
    "foot": "left",
    "height": 178,
    "weight": 78,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/119.jpg",
    "macros": {
      "speed": 66,
      "passing": 76,
      "physical": 51,
      "shooting": 77,
      "talent": 78,
      "defence": 84
    },
    "profileYtVideoId": "nXUFk64MKQ8"
  },
  {
    "draftJersey": 120,
    "name": "Pau Ruiz",
    "age": 24,
    "foot": "right",
    "height": 178,
    "weight": 66,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/120.jpg",
    "macros": {
      "speed": 72,
      "passing": 68,
      "physical": 56,
      "shooting": 76,
      "talent": 74,
      "defence": 76
    },
    "profileYtVideoId": "r2xE2rVWW04"
  },
  {
    "draftJersey": 121,
    "name": "Carlos Val",
    "age": 22,
    "foot": "right",
    "height": 183,
    "weight": 77,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/121.jpg",
    "macros": {
      "speed": 73,
      "passing": 71,
      "physical": 64,
      "shooting": 77,
      "talent": 81,
      "defence": 85
    },
    "profileYtVideoId": "y2BbItfVW_U"
  },
  {
    "draftJersey": 123,
    "name": "Marc Pluvins",
    "age": 23,
    "foot": "right",
    "height": 177,
    "weight": 70,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/123.jpg",
    "macros": {
      "speed": 72,
      "passing": 70,
      "physical": 58,
      "shooting": 78,
      "talent": 87,
      "defence": 71
    },
    "profileYtVideoId": "0cMnaodYHfw"
  },
  {
    "draftJersey": 124,
    "name": "Roger Carbó",
    "age": 24,
    "foot": "left",
    "height": 173,
    "weight": 81,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/124.jpg",
    "macros": {
      "speed": 71,
      "passing": 67,
      "physical": 49,
      "shooting": 63,
      "talent": 66,
      "defence": 62
    },
    "profileYtVideoId": "diYjs1Cmccc"
  },
  {
    "draftJersey": 125,
    "name": "Pol Montserrat",
    "age": 30,
    "foot": "right",
    "height": 181,
    "weight": 77,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/125.jpg",
    "macros": {
      "speed": 71,
      "passing": 63,
      "physical": 56,
      "shooting": 83,
      "talent": 73,
      "defence": 69
    },
    "profileYtVideoId": "nTxVdZzU1JU"
  },
  {
    "draftJersey": 126,
    "name": "Marc Amigó",
    "age": 27,
    "foot": "right",
    "height": 179,
    "weight": 72,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/126.jpg",
    "macros": {
      "speed": 67,
      "passing": 68,
      "physical": 48,
      "shooting": 69,
      "talent": 64,
      "defence": 54
    },
    "profileYtVideoId": "ZuLTzS2ZQqg"
  },
  {
    "draftJersey": 127,
    "name": "Raul Dorado",
    "age": 22,
    "foot": "right",
    "height": 194,
    "weight": 93,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/127.jpg",
    "macros": {
      "speed": 72,
      "passing": 71,
      "physical": 52,
      "shooting": 80,
      "talent": 78,
      "defence": 58
    },
    "profileYtVideoId": "nQhIuujdd_w"
  },
  {
    "draftJersey": 128,
    "name": "Dorkis Perez",
    "age": 20,
    "foot": "right",
    "height": 180,
    "weight": 74,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/128.jpg",
    "macros": {
      "speed": 72,
      "passing": 54,
      "physical": 54,
      "shooting": 78,
      "talent": 71,
      "defence": 72
    },
    "profileYtVideoId": "tLrqEiTfmGQ"
  },
  {
    "draftJersey": 129,
    "name": "Ismael Cabello",
    "age": 33,
    "foot": "right",
    "height": 180,
    "weight": 75,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/129.jpg",
    "macros": {
      "speed": 77,
      "passing": 57,
      "physical": 54,
      "shooting": 80,
      "talent": 58,
      "defence": 56
    },
    "profileYtVideoId": "gQY1ttfy3QQ"
  },
  {
    "draftJersey": 130,
    "name": "Marc Palanca",
    "age": 26,
    "foot": "right",
    "height": 174,
    "weight": 73,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/130.jpg",
    "macros": {
      "speed": 73,
      "passing": 59,
      "physical": 55,
      "shooting": 65,
      "talent": 59,
      "defence": 57
    },
    "profileYtVideoId": "TEaSxY95j7k"
  },
  {
    "draftJersey": 131,
    "name": "Victor Molina",
    "age": 25,
    "foot": "left",
    "height": 173,
    "weight": 69,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/131.jpg",
    "macros": {
      "speed": 73,
      "passing": 82,
      "physical": 56,
      "shooting": 74,
      "talent": 72,
      "defence": 71
    },
    "profileYtVideoId": "VRd06gQmo00"
  },
  {
    "draftJersey": 132,
    "name": "Llorenç Genesca",
    "age": 24,
    "foot": "right",
    "height": 187,
    "weight": 80,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/132.jpg",
    "macros": {
      "speed": 71,
      "passing": 59,
      "physical": 53,
      "shooting": 75,
      "talent": 66,
      "defence": 67
    },
    "profileYtVideoId": "GrvOv2oeAec"
  },
  {
    "draftJersey": 135,
    "name": "Aitor Cardenas",
    "age": 20,
    "foot": "left",
    "height": 165,
    "weight": 66,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/135.jpg",
    "macros": {
      "speed": 70,
      "passing": 50,
      "physical": 45,
      "shooting": 66,
      "talent": 76,
      "defence": 81
    },
    "profileYtVideoId": "_fP_9HNtfVw"
  },
  {
    "draftJersey": 137,
    "name": "Cristian Valle",
    "age": 32,
    "foot": "left",
    "height": 179,
    "weight": 74,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/137.jpg",
    "macros": {
      "speed": 71,
      "passing": 86,
      "physical": 52,
      "shooting": 76,
      "talent": 78,
      "defence": 66
    },
    "profileYtVideoId": "X6GJwAPCdZc"
  },
  {
    "draftJersey": 140,
    "name": "Joel Macarulla",
    "age": 22,
    "foot": "left",
    "height": 191,
    "weight": 82,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/140.jpg",
    "macros": {
      "speed": 72,
      "passing": 72,
      "physical": 77,
      "shooting": 72,
      "talent": 87,
      "defence": 75
    },
    "profileYtVideoId": "ugstgRzHOds"
  },
  {
    "draftJersey": 141,
    "name": "Jonathan A. Jiménez",
    "age": 32,
    "foot": "right",
    "height": 178,
    "weight": 77,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/141.jpg",
    "macros": {
      "speed": 85,
      "passing": 60,
      "physical": 73,
      "shooting": 80,
      "talent": 62,
      "defence": 62
    },
    "profileYtVideoId": "OdX-cL1vuXw"
  },
  {
    "draftJersey": 142,
    "name": "Pau Grabolosa",
    "age": 18,
    "foot": "left",
    "height": 182,
    "weight": 67,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/142.jpg",
    "macros": {
      "speed": 72,
      "passing": 75,
      "physical": 77,
      "shooting": 64,
      "talent": 72,
      "defence": 64
    },
    "profileYtVideoId": "OaO29UcbNKo"
  },
  {
    "draftJersey": 143,
    "name": "Alejandro Ramírez",
    "age": 22,
    "foot": "right",
    "height": 180,
    "weight": 73,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/143.jpg",
    "macros": {
      "speed": 69,
      "passing": 57,
      "physical": 56,
      "shooting": 73,
      "talent": 81,
      "defence": 87
    },
    "profileYtVideoId": "n41OAr1vB24"
  },
  {
    "draftJersey": 145,
    "name": "Iago Rodrigues",
    "age": 24,
    "foot": "right",
    "height": 170,
    "weight": 65,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/145.jpg",
    "macros": {
      "speed": 69,
      "passing": 63,
      "physical": 52,
      "shooting": 66,
      "talent": 68,
      "defence": 85
    },
    "profileYtVideoId": "ZwmOLtidP88"
  },
  {
    "draftJersey": 150,
    "name": "David Torregrosa",
    "age": 27,
    "foot": "right",
    "height": 171,
    "weight": 66,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/150.jpg",
    "macros": {
      "speed": 89,
      "passing": 58,
      "physical": 54,
      "shooting": 61,
      "talent": 61,
      "defence": 69
    },
    "profileYtVideoId": "Xa9jWtBV9EU"
  },
  {
    "draftJersey": 151,
    "name": "Lluis Alsina",
    "age": 21,
    "foot": "right",
    "height": 174,
    "weight": 65,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/151.jpg",
    "macros": {
      "speed": 93,
      "passing": 76,
      "physical": 74,
      "shooting": 87,
      "talent": 84,
      "defence": 73
    },
    "profileYtVideoId": "EPp_e8Lr7iE"
  },
  {
    "draftJersey": 152,
    "name": "Javier Capilla",
    "age": 35,
    "foot": "left",
    "height": 171,
    "weight": 70,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/152.jpg",
    "macros": {
      "speed": 73,
      "passing": 70,
      "physical": 40,
      "shooting": 78,
      "talent": 77,
      "defence": 78
    },
    "profileYtVideoId": "cUq_DSKpm9M"
  },
  {
    "draftJersey": 153,
    "name": "Carlos García",
    "age": 23,
    "foot": "right",
    "height": 170,
    "weight": 72,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/153.jpg",
    "macros": {
      "speed": 71,
      "passing": 72,
      "physical": 47,
      "shooting": 69,
      "talent": 82,
      "defence": 68
    },
    "profileYtVideoId": "OsoAAt6S6Hs"
  },
  {
    "draftJersey": 154,
    "name": "Raúl Morillo",
    "age": 22,
    "foot": "left",
    "height": 167,
    "weight": 66,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/154.jpg",
    "macros": {
      "speed": 79,
      "passing": 97,
      "physical": 58,
      "shooting": 70,
      "talent": 57,
      "defence": 59
    },
    "profileYtVideoId": "Jt-9R37n9As"
  },
  {
    "draftJersey": 156,
    "name": "Ivan Pérez",
    "age": 20,
    "foot": "right",
    "height": 178,
    "weight": 73,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/156.jpg",
    "macros": {
      "speed": 77,
      "passing": 52,
      "physical": 64,
      "shooting": 63,
      "talent": 62,
      "defence": 63
    },
    "profileYtVideoId": "q07ITnGXpM8"
  },
  {
    "draftJersey": 157,
    "name": "Manel Torras",
    "age": 21,
    "foot": "left",
    "height": 178,
    "weight": 70,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/157.jpg",
    "macros": {
      "speed": 65,
      "passing": 69,
      "physical": 41,
      "shooting": 74,
      "talent": 75,
      "defence": 78
    },
    "profileYtVideoId": "gXdkHMPJhNE"
  },
  {
    "draftJersey": 158,
    "name": "Marc Rodergas",
    "age": 25,
    "foot": "right",
    "height": 184,
    "weight": 74,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/158.jpg",
    "macros": {
      "speed": 71,
      "passing": 81,
      "physical": 44,
      "shooting": 70,
      "talent": 70,
      "defence": 73
    },
    "profileYtVideoId": "kZwmHRyRCm8"
  },
  {
    "draftJersey": 159,
    "name": "Antonio Segura",
    "age": 28,
    "foot": "right",
    "height": 173,
    "weight": 66,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/159.jpg",
    "macros": {
      "speed": 70,
      "passing": 72,
      "physical": 52,
      "shooting": 70,
      "talent": 54,
      "defence": 54
    },
    "profileYtVideoId": "Pux5niNBP8Q"
  },
  {
    "draftJersey": 160,
    "name": "Pau Fernández",
    "age": 21,
    "foot": "right",
    "height": 182,
    "weight": 63,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/160.jpg",
    "macros": {
      "speed": 71,
      "passing": 82,
      "physical": 62,
      "shooting": 71,
      "talent": 75,
      "defence": 82
    },
    "profileYtVideoId": "psfKYYQLx1Q"
  },
  {
    "draftJersey": 163,
    "name": "Roger Nogués",
    "age": 22,
    "foot": "right",
    "height": 187,
    "weight": 72,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/163.jpg",
    "macros": {
      "speed": 67,
      "passing": 70,
      "physical": 49,
      "shooting": 60,
      "talent": 72,
      "defence": 66
    },
    "profileYtVideoId": "VHhqIC1jpBE"
  },
  {
    "draftJersey": 164,
    "name": "Sergio Sánchez",
    "age": 29,
    "foot": "right",
    "height": 180,
    "weight": 69,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/164.jpg",
    "macros": {
      "speed": 65,
      "passing": 79,
      "physical": 43,
      "shooting": 75,
      "talent": 82,
      "defence": 84
    },
    "profileYtVideoId": "aU9fR7idStM"
  },
  {
    "draftJersey": 165,
    "name": "Cristhian E. Aguilera",
    "age": 26,
    "foot": "right",
    "height": 170,
    "weight": 70,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/165.jpg",
    "macros": {
      "speed": 74,
      "passing": 65,
      "physical": 69,
      "shooting": 68,
      "talent": 62,
      "defence": 72
    },
    "profileYtVideoId": "n-4ApXsmfZA"
  },
  {
    "draftJersey": 166,
    "name": "Gerardo Barral",
    "age": 20,
    "foot": "right",
    "height": 175,
    "weight": 68,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/166.jpg",
    "macros": {
      "speed": 63,
      "passing": 77,
      "physical": 47,
      "shooting": 69,
      "talent": 70,
      "defence": 69
    },
    "profileYtVideoId": "vjv710ffM4I"
  },
  {
    "draftJersey": 168,
    "name": "Lluc Riera",
    "age": 27,
    "foot": "right",
    "height": 186,
    "weight": 79,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/168.jpg",
    "macros": {
      "speed": 69,
      "passing": 67,
      "physical": 57,
      "shooting": 61,
      "talent": 78,
      "defence": 77
    },
    "profileYtVideoId": "dGAQN4EYVB4"
  },
  {
    "draftJersey": 169,
    "name": "Alvaro Pons",
    "age": 22,
    "foot": "right",
    "height": 181,
    "weight": 69,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/169.jpg",
    "macros": {
      "speed": 55,
      "passing": 68,
      "physical": 41,
      "shooting": 61,
      "talent": 76,
      "defence": 68
    },
    "profileYtVideoId": "avqFPZyDdxc"
  },
  {
    "draftJersey": 170,
    "name": "Juan Quero",
    "age": 38,
    "foot": "right",
    "height": 160,
    "weight": 58,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/170.jpg",
    "macros": {
      "speed": 83,
      "passing": 86,
      "physical": 67,
      "shooting": 73,
      "talent": 83,
      "defence": 74
    },
    "profileYtVideoId": "plYDQ4tuqaY"
  },
  {
    "draftJersey": 171,
    "name": "David Alba",
    "age": 36,
    "foot": "right",
    "height": 169,
    "weight": 60,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/171.jpg",
    "macros": {
      "speed": 75,
      "passing": 65,
      "physical": 75,
      "shooting": 80,
      "talent": 73,
      "defence": 64
    },
    "profileYtVideoId": "_fH2pSOO7ac"
  },
  {
    "draftJersey": 172,
    "name": "Manu Valenzuela",
    "age": 29,
    "foot": "left",
    "height": 179,
    "weight": 98,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/172.jpg",
    "macros": {
      "speed": 71,
      "passing": 92,
      "physical": 73,
      "shooting": 85,
      "talent": 60,
      "defence": 62
    },
    "profileYtVideoId": "0-NhMK0VcDk"
  },
  {
    "draftJersey": 173,
    "name": "Noel Bayarri",
    "age": 34,
    "foot": "right",
    "height": 182,
    "weight": 82,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/173.jpg",
    "macros": {
      "speed": 72,
      "passing": 64,
      "physical": 62,
      "shooting": 71,
      "talent": 72,
      "defence": 68
    },
    "profileYtVideoId": "XMe9ft_S6iQ"
  },
  {
    "draftJersey": 174,
    "name": "Jonathan Mengeli",
    "age": 33,
    "foot": "right",
    "height": 186,
    "weight": 85,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/174.jpg",
    "macros": {
      "speed": 86,
      "passing": 66,
      "physical": 82,
      "shooting": 74,
      "talent": 76,
      "defence": 77
    },
    "profileYtVideoId": "LpVhLVF07ug"
  },
  {
    "draftJersey": 175,
    "name": "Jordi Ros",
    "age": 26,
    "foot": "right",
    "height": 177,
    "weight": 73,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/175.jpg",
    "macros": {
      "speed": 72,
      "passing": 75,
      "physical": 78,
      "shooting": 86,
      "talent": 83,
      "defence": 80
    },
    "profileYtVideoId": "DUJ3_Dnqt68"
  },
  {
    "draftJersey": 176,
    "name": "Andres Serrano",
    "age": 18,
    "foot": "right",
    "height": 193,
    "weight": 82,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/176.jpg",
    "macros": {
      "speed": 74,
      "passing": 71,
      "physical": 69,
      "shooting": 69,
      "talent": 63,
      "defence": 77
    },
    "profileYtVideoId": "Gz7c5K9JeQA"
  },
  {
    "draftJersey": 177,
    "name": "Goran Ehsan",
    "age": 24,
    "foot": "left",
    "height": 171,
    "weight": 63,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/177.jpg",
    "macros": {
      "speed": 92,
      "passing": 51,
      "physical": 61,
      "shooting": 72,
      "talent": 71,
      "defence": 60
    },
    "profileYtVideoId": "5KABzNBtAxg"
  },
  {
    "draftJersey": 180,
    "name": "Kilian Durán",
    "age": 25,
    "foot": "left",
    "height": 172,
    "weight": 68,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/180.jpg",
    "macros": {
      "speed": 80,
      "passing": 85,
      "physical": 71,
      "shooting": 72,
      "talent": 81,
      "defence": 67
    },
    "profileYtVideoId": ""
  },
  {
    "draftJersey": 181,
    "name": "Victor Baranera",
    "age": 21,
    "foot": "right",
    "height": 175,
    "weight": 72,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/181.jpg",
    "macros": {
      "speed": 73,
      "passing": 69,
      "physical": 60,
      "shooting": 62,
      "talent": 74,
      "defence": 68
    },
    "profileYtVideoId": "Hj1vl2v8_1o"
  },
  {
    "draftJersey": 182,
    "name": "Francesc Purtí",
    "age": 23,
    "foot": "left",
    "height": 174,
    "weight": 71,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/182.jpg",
    "macros": {
      "speed": 73,
      "passing": 66,
      "physical": 71,
      "shooting": 74,
      "talent": 82,
      "defence": 78
    },
    "profileYtVideoId": "7ASo2-yljM0"
  },
  {
    "draftJersey": 183,
    "name": "Marc Pelaz",
    "age": 19,
    "foot": "right",
    "height": 181,
    "weight": 73,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/183.jpg",
    "macros": {
      "speed": 71,
      "passing": 78,
      "physical": 59,
      "shooting": 76,
      "talent": 86,
      "defence": 72
    },
    "profileYtVideoId": "FlmEK2F6YGA"
  },
  {
    "draftJersey": 184,
    "name": "Oscar Rivero",
    "age": 22,
    "foot": "right",
    "height": 181,
    "weight": 70,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/184.jpg",
    "macros": {
      "speed": 73,
      "passing": 60,
      "physical": 64,
      "shooting": 82,
      "talent": 87,
      "defence": 75
    },
    "profileYtVideoId": "jkWkrINFNto"
  },
  {
    "draftJersey": 188,
    "name": "Guillem Ruiz",
    "age": 24,
    "foot": "right",
    "height": 178,
    "weight": 66,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/188.jpg",
    "macros": {
      "speed": 69,
      "passing": 63,
      "physical": 52,
      "shooting": 84,
      "talent": 81,
      "defence": 80
    },
    "profileYtVideoId": "bdGGUxTi5ok"
  },
  {
    "draftJersey": 189,
    "name": "Carlos Torrentbó",
    "age": 31,
    "foot": "right",
    "height": 173,
    "weight": 70,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/189.jpg",
    "macros": {
      "speed": 73,
      "passing": 76,
      "physical": 59,
      "shooting": 73,
      "talent": 75,
      "defence": 72
    },
    "profileYtVideoId": "aDdADaJ35kw"
  },
  {
    "draftJersey": 190,
    "name": "Juan Rivas",
    "age": 34,
    "foot": "right",
    "height": 175,
    "weight": 73,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/190.jpg",
    "macros": {
      "speed": 75,
      "passing": 70,
      "physical": 66,
      "shooting": 63,
      "talent": 69,
      "defence": 70
    },
    "profileYtVideoId": "B_snlQXIp7M"
  },
  {
    "draftJersey": 192,
    "name": "Lautaro Nicolas",
    "age": 26,
    "foot": "right",
    "height": 181,
    "weight": 76,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/192.jpg",
    "macros": {
      "speed": 79,
      "passing": 70,
      "physical": 59,
      "shooting": 75,
      "talent": 69,
      "defence": 70
    },
    "profileYtVideoId": "pexA5U1pKfM"
  },
  {
    "draftJersey": 193,
    "name": "Ciprian Bezdiga",
    "age": 25,
    "foot": "left",
    "height": 190,
    "weight": 85,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/193.jpg",
    "macros": {
      "speed": 72,
      "passing": 65,
      "physical": 47,
      "shooting": 57,
      "talent": 60,
      "defence": 67
    },
    "profileYtVideoId": "WmZTk1Hxcoc"
  },
  {
    "draftJersey": 196,
    "name": "Carlos González",
    "age": 26,
    "foot": "right",
    "height": 172,
    "weight": 72,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/196.jpg",
    "macros": {
      "speed": 80,
      "passing": 82,
      "physical": 67,
      "shooting": 64,
      "talent": 77,
      "defence": 71
    },
    "profileYtVideoId": "M_1dzUeCnXg"
  },
  {
    "draftJersey": 197,
    "name": "Xavier Molas",
    "age": 41,
    "foot": "left",
    "height": 171,
    "weight": 71,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/197.jpg",
    "macros": {
      "speed": 73,
      "passing": 84,
      "physical": 72,
      "shooting": 76,
      "talent": 81,
      "defence": 78
    },
    "profileYtVideoId": "MlBWMVKjpcQ"
  },
  {
    "draftJersey": 198,
    "name": "Bernat Rovira",
    "age": 22,
    "foot": "left",
    "height": 180,
    "weight": 68,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/198.jpg",
    "macros": {
      "speed": 73,
      "passing": 94,
      "physical": 64,
      "shooting": 82,
      "talent": 79,
      "defence": 64
    },
    "profileYtVideoId": "ZeJ4HXnY_FM"
  },
  {
    "draftJersey": 199,
    "name": "Aleix Lage",
    "age": 31,
    "foot": "right",
    "height": 180,
    "weight": 80,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/199.jpg",
    "macros": {
      "speed": 87,
      "passing": 72,
      "physical": 64,
      "shooting": 65,
      "talent": 74,
      "defence": 70
    },
    "profileYtVideoId": "9j5iNlbI6q8"
  },
  {
    "draftJersey": 201,
    "name": "Emilio Naranjo",
    "age": 21,
    "foot": "right",
    "height": 157,
    "weight": 63,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/201.jpg",
    "macros": {
      "speed": 93,
      "passing": 62,
      "physical": 69,
      "shooting": 81,
      "talent": 84,
      "defence": 73
    },
    "profileYtVideoId": "w8jkpC19KEY"
  },
  {
    "draftJersey": 203,
    "name": "Josep Coca",
    "age": 31,
    "foot": "right",
    "height": 175,
    "weight": 75,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/203.jpg",
    "macros": {
      "speed": 86,
      "passing": 71,
      "physical": 68,
      "shooting": 69,
      "talent": 83,
      "defence": 71
    },
    "profileYtVideoId": "vC-5eeTZe7g"
  },
  {
    "draftJersey": 204,
    "name": "Mauro Alguacil",
    "age": 18,
    "foot": "left",
    "height": 182,
    "weight": 77,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/204.jpg",
    "macros": {
      "speed": 73,
      "passing": 76,
      "physical": 65,
      "shooting": 83,
      "talent": 68,
      "defence": 59
    },
    "profileYtVideoId": "m1GsL8rdLSc"
  },
  {
    "draftJersey": 205,
    "name": "Oriol Pons",
    "age": 20,
    "foot": "left",
    "height": 177,
    "weight": 85,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/205.jpg",
    "macros": {
      "speed": 72,
      "passing": 61,
      "physical": 78,
      "shooting": 78,
      "talent": 65,
      "defence": 65
    },
    "profileYtVideoId": "Y4UzkAbt8IM"
  },
  {
    "draftJersey": 207,
    "name": "Oriol Boada",
    "age": 24,
    "foot": "right",
    "height": 178,
    "weight": 80,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/207.jpg",
    "macros": {
      "speed": 72,
      "passing": 63,
      "physical": 53,
      "shooting": 80,
      "talent": 79,
      "defence": 73
    },
    "profileYtVideoId": "MTM90FNxsKY"
  },
  {
    "draftJersey": 210,
    "name": "Arturo Bárcena",
    "age": 23,
    "foot": "right",
    "height": 177,
    "weight": 77,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/210.jpg",
    "macros": {
      "speed": 76,
      "passing": 50,
      "physical": 67,
      "shooting": 81,
      "talent": 61,
      "defence": 65
    },
    "profileYtVideoId": "aUa5Nhmut5I"
  },
  {
    "draftJersey": 211,
    "name": "Aaron Ropero",
    "age": 21,
    "foot": "right",
    "height": 169,
    "weight": 73,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/211.jpg",
    "macros": {
      "speed": 72,
      "passing": 72,
      "physical": 57,
      "shooting": 82,
      "talent": 72,
      "defence": 68
    },
    "profileYtVideoId": "AncniIiLwkQ"
  },
  {
    "draftJersey": 212,
    "name": "Diego A. Gómez",
    "age": 23,
    "foot": "right",
    "height": 177,
    "weight": 75,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/212.jpg",
    "macros": {
      "speed": 80,
      "passing": 60,
      "physical": 68,
      "shooting": 73,
      "talent": 78,
      "defence": 70
    },
    "profileYtVideoId": "rtQ5aLensi4"
  },
  {
    "draftJersey": 213,
    "name": "Roger Bonet",
    "age": 35,
    "foot": "left",
    "height": 168,
    "weight": 59,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/213.jpg",
    "macros": {
      "speed": 71,
      "passing": 73,
      "physical": 75,
      "shooting": 73,
      "talent": 85,
      "defence": 68
    },
    "profileYtVideoId": "wUNI-IWLAC4"
  },
  {
    "draftJersey": 214,
    "name": "Marc Juanico",
    "age": 24,
    "foot": "right",
    "height": 172,
    "weight": 67,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/214.jpg",
    "macros": {
      "speed": 73,
      "passing": 57,
      "physical": 61,
      "shooting": 71,
      "talent": 77,
      "defence": 72
    },
    "profileYtVideoId": "dRROPm1eXis"
  },
  {
    "draftJersey": 215,
    "name": "Ruben G. Tremiño",
    "age": 26,
    "foot": "left",
    "height": 185,
    "weight": 85,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/215.jpg",
    "macros": {
      "speed": 71,
      "passing": 55,
      "physical": 76,
      "shooting": 83,
      "talent": 78,
      "defence": 71
    },
    "profileYtVideoId": "Wl1NWDq9bCQ"
  },
  {
    "draftJersey": 216,
    "name": "Manel Torralba",
    "age": 25,
    "foot": "right",
    "height": 192,
    "weight": 85,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/216.jpg",
    "macros": {
      "speed": 72,
      "passing": 81,
      "physical": 70,
      "shooting": 77,
      "talent": 65,
      "defence": 62
    },
    "profileYtVideoId": "6b6MJMzDOas"
  },
  {
    "draftJersey": 217,
    "name": "Jacobo Fernández",
    "age": 26,
    "foot": "right",
    "height": 185,
    "weight": 80,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/217.jpg",
    "macros": {
      "speed": 86,
      "passing": 81,
      "physical": 68,
      "shooting": 84,
      "talent": 84,
      "defence": 67
    },
    "profileYtVideoId": "4GKpazSRu3g"
  },
  {
    "draftJersey": 219,
    "name": "Luisao Macias",
    "age": 18,
    "foot": "right",
    "height": 173,
    "weight": 70,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/219.jpg",
    "macros": {
      "speed": 73,
      "passing": 73,
      "physical": 64,
      "shooting": 71,
      "talent": 67,
      "defence": 62
    },
    "profileYtVideoId": "G5U8cgIsM5U"
  },
  {
    "draftJersey": 220,
    "name": "Raúl de Regás",
    "age": 23,
    "foot": "right",
    "height": 187,
    "weight": 73,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/220.jpg",
    "macros": {
      "speed": 70,
      "passing": 88,
      "physical": 66,
      "shooting": 73,
      "talent": 65,
      "defence": 69
    },
    "profileYtVideoId": "Re5lWePqh-o"
  },
  {
    "draftJersey": 221,
    "name": "Alex Sala",
    "age": 23,
    "foot": "right",
    "height": 182,
    "weight": 70,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/221.jpg",
    "macros": {
      "speed": 72,
      "passing": 67,
      "physical": 61,
      "shooting": 73,
      "talent": 66,
      "defence": 71
    },
    "profileYtVideoId": "3YHCf0vuYDA"
  }
]
